/*global BASE_URL, console, _, Modernizr*/
/*jshint browser:true, jquery:true, undef:true, multistr: true*/

jQuery( document ).ready( function($) {
    "use strict";

    var browserWindow = $( window ),
        html          = $( this.documentElement ),
        masthead      = $( '#masthead' );

    // var _mapEl = $( '#property-map' ),
    //     _lat = _mapEl.data( 'lat' ),
    //     _lng = _mapEl.data( 'lng' );
    //
    // if (_lat !== '' && _lng !== '') {
    //     _mapEl.css({
    //         'height': 272
    //     });
    //
    //     var map = new GMaps({
    //         div: '#' + _mapEl.attr( 'id' ),
    //         lat: _lat,
    //         lng: _lng
    //     });
    //
    //     // Disable scroll zoom
    //     map.map.setOptions({
    //         scrollwheel: false
    //     });
    //
    //     map.addMarker({
    //         lat: _lat,
    //         lng: _lng,
    //         title: _mapEl.data( 'address' ),
    //         infoWindow: {
    //             content: '<p>' + _mapEl.data( 'address' ) + '</p>'
    //         }
    //     });
    // }

    var propertyHeader = $( '.property--specific' ).find( '.property__header' ),
        propertyNav    = propertyHeader.find( '.scroll-trigger' ),
        extraOffsetTop = null;

    if (  propertyHeader.length > 0 ) {

        if ( browserWindow.width() > 767 ) {
            extraOffsetTop = 120;
        } else {
            extraOffsetTop = 150;
        }


        // // Affix
        // propertyHeader.affix({
        //     offset: {
        //         top: $( '.main-content' ).offset().top
        //     }
        // });


        // ScrollSpy
        $( 'body' ).scrollspy({
            target: '.property__header',
            offset: extraOffsetTop + 5
        });


        // Smooth Scroll
        propertyNav.on( 'click', 'a[href^="#"]', function() {
            var hash = this.hash;

            if ( propertyHeader.hasClass('affix-top') ) {

                $( 'html, body' ).animate({
                    scrollTop: $( hash ).offset().top - ( extraOffsetTop + 87 )
                }, 'slow');

            } else {

                $( 'html, body' ).animate({
                    scrollTop: $( hash ).offset().top - extraOffsetTop
                }, 'slow');

            }
        });

    }

    // handle property back button event
    var propertyBackBtn = $( '#property-back-btn' );
    propertyBackBtn.on('click', () => {
        // There's a bug in this if you access a property page directly, then
        // there is no history to go back and history's length is 2
        // if history's length is greater than 1, then go back
        // else, go to homepage using location.href (will load homepage)
        // if (history.length > 1) {
        //     history.back();
        // } else {
        //     location.href = location.origin;
        // }
        if (document.referrer) {
            location.href = document.referrer;
        } else {
            location.href = location.origin;
        }
    });
});
